import { makeAutoObservable } from 'mobx';
import { Vote } from '~/definitions/vote';
import onVotesChange from './fn/onVotesChange';
import setInitialVoteData from './fn/setInitialVoteData';
import submitVote from './fn/submitVote';
import getVoteType from './fn/getVoteType';

export default class VoteStore {
    votes: Vote[] = [];
    remainingExtraVotesQuota: number = 0;
    isVoteInProgress: boolean = false;
    voteStatus: string = '';

    constructor() {
        this.resetToDefault();
        makeAutoObservable(this);
    }

    resetToDefault() {
        this.votes = [];
        this.remainingExtraVotesQuota = 0;
        this.voteStatus = '';
        this.isVoteInProgress = false;
    }

    setVotes(votes: Vote[]) {
        this.votes = votes;
    }

    setRemainingExtraVotesQuota(quota: number) {
        this.remainingExtraVotesQuota = quota;
    }

    setVoteStatus(status: string) {
        this.voteStatus = status;
    }

    setIsVoteInProgress(isInProgress: boolean) {
        this.isVoteInProgress = isInProgress;
    }

    onVotesChange = onVotesChange;
    setInitialVoteData = setInitialVoteData;
    submitVote = submitVote;
    getVoteType = getVoteType;
}
